import React, { useEffect, useState } from "react";
import { Box, Autocomplete, TextField } from "@mui/material";
import { useDataProvider, useNotify } from "react-admin";

export const SelectProviderInput = ({ selectedProvider, setSelectedProvider }) => {
  const notify = useNotify();
  const dataProvider = useDataProvider();
  //   const { permissions } = usePermissions();
  //   const profile = JSON.parse(localStorage.getItem("profile"));

  const [providers, setProviders] = useState([]);

  useEffect(() => {
    dataProvider
      .getList("providers", {
        sort: { field: "name", order: "ASC" },
        filter: {},
      })
      .then(({ data }) => setProviders(data))
      .catch(() => {
        notify("Error cargando proveedores", { type: "error" });
      });
  }, [dataProvider, notify]);

  return (
    <Box sx={{ mb: 1 }}>
      <Autocomplete
        size="small"
        options={providers}
        getOptionLabel={(option) => option?.first_name || ""}
        value={providers.find((provider) => provider.id === selectedProvider) || null}
        onChange={(event, newValue) => setSelectedProvider(newValue ? newValue.id : "")}
        renderInput={(params) => <TextField {...params} label="Proveedor" variant="outlined" />}
        sx={{ width: 200 }}
      />
    </Box>
  );
};
